import { render, staticRenderFns } from "./ProjectDetailsContactInformation.vue?vue&type=template&id=38f2f236&scoped=true&"
import script from "./ProjectDetailsContactInformation.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsContactInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsContactInformation.vue?vue&type=style&index=0&id=38f2f236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2f236",
  null
  
)

export default component.exports